module.exports = __webpack_public_path__ + "static/media/International_Travel_insurance.09f5ea0a.svg";